
import { defineComponent, ref, onMounted, computed } from 'vue'
import LoadingButton from '@/views/components/LoadingButton.vue'
import ContentLayout from '@/views/layout/ContentLayout.vue'
import { Kamoku } from '@/repositories/fuzoku-meisai/data'
import { junsokuRepositories } from '@/repositories/fuzoku-meisai/junsoku/junsokuRepositories'
import { callApiWrapper } from '@/views/callApiWrapper'
import ResponseResultAlert from '@/views/components/ResponseResultAlert.vue'
import HonbuhiSettingItem from '@/views/fuzoku-meisai/junsoku/HonbuhiSettingItem.vue'
import { HonbuhiUiItem } from '@/views/fuzoku-meisai/junsoku/data'
import { UiItemsLogic } from '@/views/fuzoku-meisai/uiItemsLogic'
import JunsokuSettingTitle from '@/views/fuzoku-meisai/junsoku/JunsokuSettingTitle.vue'

const repository = junsokuRepositories.honbuhi

export default defineComponent({
  components: {
    JunsokuSettingTitle,
    HonbuhiSettingItem,
    ResponseResultAlert,
    ContentLayout,
    LoadingButton
  },
  setup () {
    let kamokuSource: Kamoku[] = []
    const loading = ref(false)
    const isSucceedRequest = ref(false)
    const requestError = ref<string | null>(null)
    const items = ref<HonbuhiUiItem[]>([])
    const isAllValid = computed(() => {
      const allCount = items.value.length
      if (allCount === 0) {
        return true
      }
      return allCount === items.value.filter(i => i.isValid).length
    })

    onMounted(async () => {
      loading.value = true
      await callApiWrapper(requestError, async () => {
        const data = await repository.list()
        kamokuSource = data.kamokuSources
        items.value = data.items.map(value => ({ item: value, isValid: true }))
      })
      loading.value = false
    })

    const onClickRegister = async () => {
      loading.value = true
      onDismissAlert()

      await callApiWrapper(requestError, async () => {
        const params = items.value.map(v => v.item)
        await repository.save(params)
        const data = await repository.list()
        kamokuSource = data.kamokuSources
        items.value = data.items.map(value => ({ item: value, isValid: true }))
        isSucceedRequest.value = true
      })
      loading.value = false
    }

    const onDismissAlert = () => {
      isSucceedRequest.value = false
      requestError.value = null
    }

    const addItem = () => {
      const newId = UiItemsLogic.makeId(items.value)
      items.value.push({
        isValid: false,
        item: {
          id: newId,
          itemName: '',
          honbuhi: 0,
          haifukijun: '',
          settings: {
            sources: kamokuSource,
            targets: []
          }
        }
      })
    }

    const upItem = (item: HonbuhiUiItem) => UiItemsLogic.upUiItem(items.value, item)

    const downItem = (item: HonbuhiUiItem) => UiItemsLogic.downUiItem(items.value, item)

    const trashItem = (item: HonbuhiUiItem) => UiItemsLogic.removeUiItem(items.value, item)

    const onChangeInput = (item: HonbuhiUiItem) => UiItemsLogic.updateUiItem(items.value, item)

    return {
      loading,
      isAllValid,
      isSucceedRequest,
      requestError,
      items,
      onClickRegister,
      onDismissAlert,
      addItem,
      upItem,
      downItem,
      trashItem,
      onChangeInput
    }
  }
})
